var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5498",
    "data-name": "Group 5498",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.948,
    height: 50.544,
    viewBox: "0 0 40.948 50.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M59.291,223.334a19.919,19.919,0,0,0-4.65-7.281l-4.972-4.972a2.385,2.385,0,0,1,0-3.376l.056-.056a4.019,4.019,0,0,1,5.672,0l3.253,3.252,0,.005a5.436,5.436,0,0,0,3.927,1.573A9.628,9.628,0,0,1,69.6,214.9c1.833,1.8,2.763,4.58,2.763,8.268a.736.736,0,0,0,1.473,0c0-4.1-1.078-7.235-3.2-9.32a11.068,11.068,0,0,0-8.076-2.834,3.952,3.952,0,0,1-2.643-.946,33.32,33.32,0,0,0-.968-7.657l0-.016-.616-2.275a.736.736,0,1,0-1.422.385l.614,2.268a31.853,31.853,0,0,1,.873,5.79l-1.948-1.948a5.5,5.5,0,0,0-7.755,0l-.056.056a3.858,3.858,0,0,0,0,5.458l4.972,4.972a18.453,18.453,0,0,1,4.308,6.746,9.871,9.871,0,0,0,.851,1.759.736.736,0,0,0,1.256-.769,8.391,8.391,0,0,1-.724-1.5Z",
    transform: "translate(-47.498 -179.975)",
    fill: "#fe4e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M114.2,10.386l1.872,6.916a.736.736,0,1,0,1.422-.385l-1.87-6.908a2.545,2.545,0,0,1,1.924-3.091,2.533,2.533,0,0,1,3.018,1.851l3.528,14.463h-.046a.736.736,0,0,0,0,1.473h2.193a.736.736,0,0,0,0-1.473h-.476V4a2.525,2.525,0,1,1,5.051,0V23.232h-.53a.736.736,0,1,0,0,1.473h2.193a.736.736,0,1,0,0-1.473h-.19V6.134a2.525,2.525,0,1,1,5.05,0v3.49a.736.736,0,1,0,1.473,0V6.134a4,4,0,0,0-6.621-3.015,4,4,0,0,0-7.9.88V17.834l-2.3-9.42a4,4,0,0,0-4.767-2.932,4.018,4.018,0,0,0-3.033,4.889l0,.016Z",
    transform: "translate(-107.536 0)",
    fill: "#fe4e4e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M210.978,111.225a3.79,3.79,0,0,0-6.946.806l-2.242,6.258v-6.768a.736.736,0,0,0-1.473,0v10.271h-.52a.736.736,0,1,0,0,1.473h2.193a.736.736,0,0,0,.107-1.464l3.331-9.3c.006-.016.011-.033.016-.049a2.317,2.317,0,0,1,4.468,1.229l-2.507,6.98a30.416,30.416,0,0,0-1.8,10.31v8.158a8.239,8.239,0,0,1-8.23,8.23h-7.326a8.14,8.14,0,0,1-4.958-1.671.736.736,0,1,0-.89,1.173,9.6,9.6,0,0,0,5.849,1.971h7.326a9.714,9.714,0,0,0,9.7-9.7v-8.158a28.947,28.947,0,0,1,1.709-9.812l2.517-7.006q.009-.025.016-.05A3.767,3.767,0,0,0,210.978,111.225Z",
    transform: "translate(-170.517 -98.291)",
    fill: "#fe4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.598ef9e89021452aa59fc693c9c630d6.svg";
export { ForwardRef as ReactComponent };